import { PureComponent } from "react";
import ParagraphComponent from "/components/core/paragraph/paragraph-component";
import FactCardComponent from "/components/core/fact-card/fact-card-component";
import { StyledFactCardsComponent } from "./fact-cards-component.scss";

export default class FactCardsComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { paragraph, general, cards } = this.props;

    return (
      <StyledFactCardsComponent className="fact-cards-component">
        <div className="header">
          <ParagraphComponent {...paragraph} />
        </div>

        <div className="cards">
          {cards.map((card, index) => (
            <FactCardComponent key={index} {...card} {...general} />
          ))}
        </div>
      </StyledFactCardsComponent>
    );
  }
}

FactCardsComponent.defaultProps = {
  cards: []
};
